module.exports = __webpack_public_path__ + "img/P5181375.edde2646.jpg";